interface IProgressInfo {
    id: string;
    refreshTime: number;
    toRefresh: string[];
}

interface IProgressRequest {
    id: string;
}
interface IProgressResponse {
    from: number | undefined;
    to: number | undefined;
    state: ProgressStates;
}

type ProgressStates = 'Waiting' | 'InProgress' | 'DoneOk' | 'DoneError' ;

class SiteElementProgress
    extends QueryElement<SVGElement> {

    private readonly _info: IProgressInfo;
    private readonly _progress: IQueryElement;
    private readonly _text: IQueryElement;
    private readonly _description: IQueryElement;

    private _refreshTimer: number | null = null;


    constructor(card: ISiteCard, element: SVGElement) {
        super(element, true);
        
        let path = this.getAttr('data-path');
        this._info = card.Model.get((path && SiteModel.split(path)) || []) as IProgressInfo;
        if (this._info === undefined)
            throw "Cannot fetch info";

        let progress = this.query(".progress-foreground").first();
        let text = this.query(".progress-text").first();
        let description = this.query(".progress-description").first();
        
        if (progress == null || text == null || description == null)
            throw "Not all elements found!";
        
        this._progress = progress;
        this._text = text;
        this._description = description;
        
        this.refresh();
    }

    async refresh() {

        if (this._info.refreshTime > 0) {
            this._refreshTimer = setTimeout(async () => {
                await this.refresh();
            }, this._info.refreshTime * 1000);
        }
        
        let progressRequest: IProgressRequest = {
            id: this._info.id
        };

        let request = new QueryRequest('Api/Progress', {
            contentType: 'json',
            method: 'post',
            data: JSON.stringify(progressRequest)
        });

        let response = await request.request();
        let progressResponse = await response.json() as IProgressResponse;
        
        let number = 0;
        if (progressResponse.from != null && progressResponse.to != null)
        {
            number = Math.floor(progressResponse.from / progressResponse.to * 100);
            this._description.setHtml(progressResponse.from + " / " + progressResponse.to);
        }

        switch(progressResponse.state)
        {
            case "Waiting":
                this._progress.setAttr("stroke-dasharray", "0, 100");
                this._text.setHtml("...");
                break;
            case "InProgress":
                this._progress.setAttr("stroke-dasharray", number + ", 100");
                this._text.setHtml(number + "%");
                break;
            case "DoneError":
                this._progress.setAttr("stroke-dasharray", "100, 100");
                this._text.setHtml("ERROR");
                this.stop();
                break;
            case "DoneOk":
                this._progress.setAttr("stroke-dasharray", "100, 100");
                this._text.setHtml("100%");
                this.stop();

                if (this._info.toRefresh && this._info.toRefresh.length > 0) {
                    Site.getSite().trigger(
                        "qts.observer.change", 
                        false, 
                        new ObserverChangeEvent(undefined, this._info.toRefresh));
                }
                break;
        }


    }

    stop() {
        if (this._refreshTimer)
            clearTimeout(this._refreshTimer);
    }

    async remove(removeInner = true) {
        await super.remove(removeInner);

        this.stop();
    }
}